export const speechPlayerSelector = state => state.speechPlayer;
export const playSpeechSelector = state => state.playSpeech;
export const pauseSpeechSelector = state => state.pauseSpeech;
export const resumeSpeechSelector = state => state.resumeSpeech;
export const stopSpeechSelector = state => state.stopSpeech;
export const openSpeechPlayerSelector = state => state.openSpeechPlayer;
export const closeSpeechPlayerSelector = state => state.closeSpeechPlayer;
export const downloadCurrentAudioSelector = state => state.downloadCurrentAudio;

